var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91506 3.24591H3.51506M14.7151 3.24591H13.1151M3.51506 3.24591L3.51506 13.25C3.51506 14.3546 4.41049 15.25 5.51506 15.25H11.1151C12.2196 15.25 13.1151 14.3546 13.1151 13.25L13.1151 3.24591M3.51506 3.24591H5.11506M13.1151 3.24591H11.5151M5.11506 3.24591L5.11506 2.75C5.11506 1.64543 6.01049 0.75 7.11506 0.75H9.51506C10.6196 0.75 11.5151 1.64543 11.5151 2.75L11.5151 3.24591M5.11506 3.24591H11.5151",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81543 7V11.5M9.81543 7V11.5",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridDeleteIcon);
export default __webpack_public_path__ + "static/media/grid-delete-icon.60c36121fce99db2d667b186cba4ecdb.svg";
export { ForwardRef as ReactComponent };